/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){ .company-branch-editor-dialog{width:100%}}@media screen and (min-width:600px){ .company-branch-editor-dialog{width:400px}} .company-branch-editor-dialog .mat-dialog-container{padding:0} .company-branch-editor-dialog .mat-dialog-container .mat-toolbar{flex:1 0 auto;min-height:initial} .company-branch-editor-dialog .dialog-content-wrapper{max-height:85vh;display:flex;flex-direction:column}"];
export { styles as styles };
